import { useEffect } from "react";
import { registerServiceWorker } from "../../lib/webPush";

/** Register the push service worker early so subscriptions work without visiting Profile. */
export default function PushBootstrap() {
  useEffect(() => {
    registerServiceWorker();
  }, []);
  return null;
}
